/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

// NOTE: keep it in sync with edit rotation VERTICAL_SPACING, LEFT_SPACING
export const VERTICAL_SPACING = 40;
export const LEFT_SPACING = 2;
export const WIDTH = 400;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div({
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	margin: `0 ${VERTICAL_SPACING / 2}px 0 0`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxWidth: `${WIDTH}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minWidth: `${WIDTH}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `0 ${VERTICAL_SPACING / 2}px 0 ${LEFT_SPACING}px`,
	position: 'relative',
});
